// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StepperHeader_headerContainer__LkoCm {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  font-family: 'CircularXXWeb-Book', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.StepperHeader_headerInner__xXxgS {
  max-width: 1360px;
  margin: 0 auto;
  padding: 0.75rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  min-height: 72px;
}

/* Brand Logo */
.StepperHeader_logoWrapper__4nmxP {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  text-decoration: none;
  cursor: pointer;
  flex-shrink: 0;
}

.StepperHeader_logoImg__2cHXR {
  height: 40px;
  width: auto;
  object-fit: contain;
}

/* Desktop Stepper */
.StepperHeader_desktopStepper__PGBXH {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  max-width: 860px;
}

.StepperHeader_stepperTrack__NUxmJ {
  display: flex;
  align-items: center;
  width: 100%;
}

.StepperHeader_stepItemWrapper__xAdC1 {
  display: flex;
  align-items: center;
  flex: 1 1;
}

.StepperHeader_stepItemWrapper__xAdC1:last-child {
  flex: 0 0 auto;
}

.StepperHeader_stepNode__z2nAX {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  padding: 0.35rem 0.6rem;
  border-radius: 9999px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
}

.StepperHeader_stepNode__z2nAX:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.StepperHeader_stepNode__z2nAX.StepperHeader_accessible__u\\+BG-:hover {
  background-color: #f1f5f9;
  transform: translateY(-1px);
}

.StepperHeader_stepNode__z2nAX.StepperHeader_disabled__Q2n0I {
  cursor: not-allowed;
  opacity: 0.55;
}

.StepperHeader_stepNode__z2nAX.StepperHeader_current__1Ks1Y {
  background-color: #eff6ff;
}

/* Step Circle / Icon */
.StepperHeader_stepCircle__CHssO {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.82rem;
  font-weight: 600;
  flex-shrink: 0;
  transition: all 0.2s ease;
  background-color: #f1f5f9;
  color: #64748b;
  border: 1.5px solid #cbd5e1;
}

.StepperHeader_stepNode__z2nAX.StepperHeader_completed__2zKOE .StepperHeader_stepCircle__CHssO {
  background-color: #10b981;
  color: #ffffff;
  border-color: #10b981;
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.25);
}

.StepperHeader_stepNode__z2nAX.StepperHeader_current__1Ks1Y .StepperHeader_stepCircle__CHssO {
  background-color: #2563eb;
  color: #ffffff;
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.15);
}

.StepperHeader_stepNode__z2nAX.StepperHeader_rejectedNeedsFix__DSbPb .StepperHeader_stepCircle__CHssO {
  background-color: #ef4444;
  color: #ffffff;
  border-color: #ef4444;
}

/* Step Label */
.StepperHeader_stepLabel__13bF6 {
  font-size: 0.88rem;
  font-weight: 500;
  color: #64748b;
  transition: color 0.2s ease;
}

.StepperHeader_stepNode__z2nAX.StepperHeader_current__1Ks1Y .StepperHeader_stepLabel__13bF6 {
  color: #1e3a8a;
  font-weight: 700;
}

.StepperHeader_stepNode__z2nAX.StepperHeader_completed__2zKOE .StepperHeader_stepLabel__13bF6 {
  color: #0f172a;
}

/* Connecting Line */
.StepperHeader_stepLine__YFovQ {
  flex: 1 1;
  height: 2px;
  background-color: #e2e8f0;
  margin: 0 0.5rem;
  min-width: 20px;
  transition: background-color 0.2s ease;
}

.StepperHeader_stepLine__YFovQ.StepperHeader_completedLine__PZg7D {
  background-color: #10b981;
}

/* Right Actions & Logout */
.StepperHeader_rightActions__cizxE {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  flex-shrink: 0;
}

.StepperHeader_rejectionBadge__iCMgT {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
  padding: 0.35rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.StepperHeader_logoutBtn__yMQmf {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  color: #475569;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.StepperHeader_logoutBtn__yMQmf:hover {
  background: #fef2f2;
  border-color: #fca5a5;
  color: #dc2626;
  transform: translateY(-1px);
}

.StepperHeader_logoutBtn__yMQmf svg {
  width: 18px;
  height: 18px;
  transition: transform 0.2s ease;
}

.StepperHeader_logoutBtn__yMQmf:hover svg {
  transform: translateX(2px);
}

/* Mobile Top Controls */
.StepperHeader_mobileControls__211aT {
  display: none;
  align-items: center;
  gap: 0.75rem;
}

.StepperHeader_mobileStepBadge__afJGm {
  background: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
  padding: 0.35rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.82rem;
  font-weight: 600;
}

.StepperHeader_hamburgerBtn__D8Zcg {
  background: none;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  cursor: pointer;
  padding: 0;
  transition: background-color 0.2s ease;
}

.StepperHeader_hamburgerBtn__D8Zcg:hover {
  background-color: #f8fafc;
}

.StepperHeader_hamburgerBar__SQ6KF {
  width: 20px;
  height: 2px;
  background-color: #1e293b;
  border-radius: 2px;
  transition: all 0.25s ease;
}

/* Mobile Slide-out Drawer */
.StepperHeader_drawerBackdrop__ZP\\+XZ {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(4px);
  z-index: 1100;
  display: flex;
  justify-content: flex-end;
  animation: StepperHeader_fadeIn__N833s 0.2s ease;
}

.StepperHeader_drawerPanel__xfWtC {
  width: 85%;
  max-width: 360px;
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  animation: StepperHeader_slideLeft__5ii1o 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

.StepperHeader_drawerHeader__8WPCq {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.StepperHeader_drawerTitle__Ct9fo {
  font-size: 1.1rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.StepperHeader_drawerCloseBtn__x1F\\+N {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #64748b;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  line-height: 1;
}

.StepperHeader_drawerCloseBtn__x1F\\+N:hover {
  background-color: #f1f5f9;
  color: #0f172a;
}

.StepperHeader_drawerBody__q4vMm {
  flex: 1 1;
  overflow-y: auto;
  padding: 1.25rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.StepperHeader_drawerStepItem__-cXko {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.85rem 1rem;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
}

.StepperHeader_drawerStepItem__-cXko.StepperHeader_accessible__u\\+BG-:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.StepperHeader_drawerStepItem__-cXko.StepperHeader_current__1Ks1Y {
  background: #eff6ff;
  border-color: #93c5fd;
}

.StepperHeader_drawerStepItem__-cXko.StepperHeader_disabled__Q2n0I {
  opacity: 0.5;
  cursor: not-allowed;
  background: #f8fafc;
}

.StepperHeader_drawerStepInfo__CwbbO {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.StepperHeader_drawerStepTitle__jt-Hx {
  font-size: 0.95rem;
  font-weight: 600;
  color: #0f172a;
}

.StepperHeader_drawerStepDesc__hi4UA {
  font-size: 0.78rem;
  color: #64748b;
  margin-top: 2px;
}

.StepperHeader_drawerStepStatusBadge__sFwyl {
  font-size: 0.72rem;
  font-weight: 600;
  padding: 0.2rem 0.5rem;
  border-radius: 9999px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.StepperHeader_drawerStepStatusBadge__sFwyl.StepperHeader_completed__2zKOE {
  background: #d1fae5;
  color: #065f46;
}

.StepperHeader_drawerStepStatusBadge__sFwyl.StepperHeader_current__1Ks1Y {
  background: #dbeafe;
  color: #1e40af;
}

.StepperHeader_drawerStepStatusBadge__sFwyl.StepperHeader_locked__KPGU6 {
  background: #f1f5f9;
  color: #94a3b8;
}

.StepperHeader_drawerFooter__1Si-b {
  padding: 1.25rem 1.5rem;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}

.StepperHeader_drawerLogoutBtn__IV6Eo {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #fecaca;
  color: #dc2626;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.StepperHeader_drawerLogoutBtn__IV6Eo:hover {
  background: #fee2e2;
}

/* Animations */
@keyframes StepperHeader_fadeIn__N833s {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes StepperHeader_slideLeft__5ii1o {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}

/* Responsive Breakpoints */
@media (max-width: 1024px) {
  .StepperHeader_stepLabel__13bF6 {
    display: none;
  }
  .StepperHeader_stepNode__z2nAX.StepperHeader_current__1Ks1Y .StepperHeader_stepLabel__13bF6 {
    display: block;
  }
}

@media (max-width: 768px) {
  .StepperHeader_desktopStepper__PGBXH {
    display: none;
  }

  .StepperHeader_mobileControls__211aT {
    display: flex;
  }

  .StepperHeader_rejectionBadge__iCMgT {
    display: none;
  }

  .StepperHeader_logoutBtn__yMQmf {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/StepperHeader.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,yCAAyC;EACzC,oGAAoG;AACtG;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,gDAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,6EAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,wBAAwB,EAAE;AACjC;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".headerContainer {\n  position: sticky;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  background: #ffffff;\n  border-bottom: 1px solid #e2e8f0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  font-family: 'CircularXXWeb-Book', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.headerInner {\n  max-width: 1360px;\n  margin: 0 auto;\n  padding: 0.75rem 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5rem;\n  min-height: 72px;\n}\n\n/* Brand Logo */\n.logoWrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  text-decoration: none;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.logoImg {\n  height: 40px;\n  width: auto;\n  object-fit: contain;\n}\n\n/* Desktop Stepper */\n.desktopStepper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  max-width: 860px;\n}\n\n.stepperTrack {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.stepItemWrapper {\n  display: flex;\n  align-items: center;\n  flex: 1;\n}\n\n.stepItemWrapper:last-child {\n  flex: 0 0 auto;\n}\n\n.stepNode {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: none;\n  border: none;\n  padding: 0.35rem 0.6rem;\n  border-radius: 9999px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  user-select: none;\n}\n\n.stepNode:focus-visible {\n  outline: 2px solid #2563eb;\n  outline-offset: 2px;\n}\n\n.stepNode.accessible:hover {\n  background-color: #f1f5f9;\n  transform: translateY(-1px);\n}\n\n.stepNode.disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.stepNode.current {\n  background-color: #eff6ff;\n}\n\n/* Step Circle / Icon */\n.stepCircle {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.82rem;\n  font-weight: 600;\n  flex-shrink: 0;\n  transition: all 0.2s ease;\n  background-color: #f1f5f9;\n  color: #64748b;\n  border: 1.5px solid #cbd5e1;\n}\n\n.stepNode.completed .stepCircle {\n  background-color: #10b981;\n  color: #ffffff;\n  border-color: #10b981;\n  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.25);\n}\n\n.stepNode.current .stepCircle {\n  background-color: #2563eb;\n  color: #ffffff;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.15);\n}\n\n.stepNode.rejectedNeedsFix .stepCircle {\n  background-color: #ef4444;\n  color: #ffffff;\n  border-color: #ef4444;\n}\n\n/* Step Label */\n.stepLabel {\n  font-size: 0.88rem;\n  font-weight: 500;\n  color: #64748b;\n  transition: color 0.2s ease;\n}\n\n.stepNode.current .stepLabel {\n  color: #1e3a8a;\n  font-weight: 700;\n}\n\n.stepNode.completed .stepLabel {\n  color: #0f172a;\n}\n\n/* Connecting Line */\n.stepLine {\n  flex: 1;\n  height: 2px;\n  background-color: #e2e8f0;\n  margin: 0 0.5rem;\n  min-width: 20px;\n  transition: background-color 0.2s ease;\n}\n\n.stepLine.completedLine {\n  background-color: #10b981;\n}\n\n/* Right Actions & Logout */\n.rightActions {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  flex-shrink: 0;\n}\n\n.rejectionBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  background: #fef2f2;\n  color: #dc2626;\n  border: 1px solid #fecaca;\n  padding: 0.35rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n.logoutBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n  color: #475569;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.logoutBtn:hover {\n  background: #fef2f2;\n  border-color: #fca5a5;\n  color: #dc2626;\n  transform: translateY(-1px);\n}\n\n.logoutBtn svg {\n  width: 18px;\n  height: 18px;\n  transition: transform 0.2s ease;\n}\n\n.logoutBtn:hover svg {\n  transform: translateX(2px);\n}\n\n/* Mobile Top Controls */\n.mobileControls {\n  display: none;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.mobileStepBadge {\n  background: #eff6ff;\n  color: #1d4ed8;\n  border: 1px solid #bfdbfe;\n  padding: 0.35rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.82rem;\n  font-weight: 600;\n}\n\n.hamburgerBtn {\n  background: none;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  cursor: pointer;\n  padding: 0;\n  transition: background-color 0.2s ease;\n}\n\n.hamburgerBtn:hover {\n  background-color: #f8fafc;\n}\n\n.hamburgerBar {\n  width: 20px;\n  height: 2px;\n  background-color: #1e293b;\n  border-radius: 2px;\n  transition: all 0.25s ease;\n}\n\n/* Mobile Slide-out Drawer */\n.drawerBackdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.5);\n  backdrop-filter: blur(4px);\n  z-index: 1100;\n  display: flex;\n  justify-content: flex-end;\n  animation: fadeIn 0.2s ease;\n}\n\n.drawerPanel {\n  width: 85%;\n  max-width: 360px;\n  height: 100%;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);\n  animation: slideLeft 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.drawerHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.drawerTitle {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.drawerCloseBtn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #64748b;\n  cursor: pointer;\n  padding: 0.25rem 0.5rem;\n  border-radius: 6px;\n  line-height: 1;\n}\n\n.drawerCloseBtn:hover {\n  background-color: #f1f5f9;\n  color: #0f172a;\n}\n\n.drawerBody {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1.25rem 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.drawerStepItem {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.85rem 1rem;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.drawerStepItem.accessible:hover {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.drawerStepItem.current {\n  background: #eff6ff;\n  border-color: #93c5fd;\n}\n\n.drawerStepItem.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background: #f8fafc;\n}\n\n.drawerStepInfo {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.drawerStepTitle {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.drawerStepDesc {\n  font-size: 0.78rem;\n  color: #64748b;\n  margin-top: 2px;\n}\n\n.drawerStepStatusBadge {\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 0.2rem 0.5rem;\n  border-radius: 9999px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.drawerStepStatusBadge.completed {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.drawerStepStatusBadge.current {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.drawerStepStatusBadge.locked {\n  background: #f1f5f9;\n  color: #94a3b8;\n}\n\n.drawerFooter {\n  padding: 1.25rem 1.5rem;\n  border-top: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.drawerLogoutBtn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.75rem;\n  border-radius: 8px;\n  background: #ffffff;\n  border: 1px solid #fecaca;\n  color: #dc2626;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.drawerLogoutBtn:hover {\n  background: #fee2e2;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideLeft {\n  from { transform: translateX(100%); }\n  to { transform: translateX(0); }\n}\n\n/* Responsive Breakpoints */\n@media (max-width: 1024px) {\n  .stepLabel {\n    display: none;\n  }\n  .stepNode.current .stepLabel {\n    display: block;\n  }\n}\n\n@media (max-width: 768px) {\n  .desktopStepper {\n    display: none;\n  }\n\n  .mobileControls {\n    display: flex;\n  }\n\n  .rejectionBadge {\n    display: none;\n  }\n\n  .logoutBtn {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerContainer": `StepperHeader_headerContainer__LkoCm`,
	"headerInner": `StepperHeader_headerInner__xXxgS`,
	"logoWrapper": `StepperHeader_logoWrapper__4nmxP`,
	"logoImg": `StepperHeader_logoImg__2cHXR`,
	"desktopStepper": `StepperHeader_desktopStepper__PGBXH`,
	"stepperTrack": `StepperHeader_stepperTrack__NUxmJ`,
	"stepItemWrapper": `StepperHeader_stepItemWrapper__xAdC1`,
	"stepNode": `StepperHeader_stepNode__z2nAX`,
	"accessible": `StepperHeader_accessible__u+BG-`,
	"disabled": `StepperHeader_disabled__Q2n0I`,
	"current": `StepperHeader_current__1Ks1Y`,
	"stepCircle": `StepperHeader_stepCircle__CHssO`,
	"completed": `StepperHeader_completed__2zKOE`,
	"rejectedNeedsFix": `StepperHeader_rejectedNeedsFix__DSbPb`,
	"stepLabel": `StepperHeader_stepLabel__13bF6`,
	"stepLine": `StepperHeader_stepLine__YFovQ`,
	"completedLine": `StepperHeader_completedLine__PZg7D`,
	"rightActions": `StepperHeader_rightActions__cizxE`,
	"rejectionBadge": `StepperHeader_rejectionBadge__iCMgT`,
	"logoutBtn": `StepperHeader_logoutBtn__yMQmf`,
	"mobileControls": `StepperHeader_mobileControls__211aT`,
	"mobileStepBadge": `StepperHeader_mobileStepBadge__afJGm`,
	"hamburgerBtn": `StepperHeader_hamburgerBtn__D8Zcg`,
	"hamburgerBar": `StepperHeader_hamburgerBar__SQ6KF`,
	"drawerBackdrop": `StepperHeader_drawerBackdrop__ZP+XZ`,
	"fadeIn": `StepperHeader_fadeIn__N833s`,
	"drawerPanel": `StepperHeader_drawerPanel__xfWtC`,
	"slideLeft": `StepperHeader_slideLeft__5ii1o`,
	"drawerHeader": `StepperHeader_drawerHeader__8WPCq`,
	"drawerTitle": `StepperHeader_drawerTitle__Ct9fo`,
	"drawerCloseBtn": `StepperHeader_drawerCloseBtn__x1F+N`,
	"drawerBody": `StepperHeader_drawerBody__q4vMm`,
	"drawerStepItem": `StepperHeader_drawerStepItem__-cXko`,
	"drawerStepInfo": `StepperHeader_drawerStepInfo__CwbbO`,
	"drawerStepTitle": `StepperHeader_drawerStepTitle__jt-Hx`,
	"drawerStepDesc": `StepperHeader_drawerStepDesc__hi4UA`,
	"drawerStepStatusBadge": `StepperHeader_drawerStepStatusBadge__sFwyl`,
	"locked": `StepperHeader_locked__KPGU6`,
	"drawerFooter": `StepperHeader_drawerFooter__1Si-b`,
	"drawerLogoutBtn": `StepperHeader_drawerLogoutBtn__IV6Eo`
};
export default ___CSS_LOADER_EXPORT___;
